import Main from './PrivacyByDesignMain'
import New from './PrivacyByDesignNew'
import Show from './PrivacyByDesignShow'
import Edit from './PrivacyByDesignEdit'

export default {
  Main,
  New,
  Show,
  Edit,
}
